module.exports = __webpack_public_path__ + "static/media/R.b1c41701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/R.jpg
// module id = 86
// module chunks = 0